import { INCLUSOES_DO_PRO } from '../../constants/planos';
import type { Pilar } from '../../nucleo/pilaresDoPainel';

// A JORNADA DO DESBLOQUEIO: as três etapas do método (o diagnóstico, o planejamento, a execução)
// na ordem, a da vez com o botão e as de depois trancadas, e o que o Maestra PRO inclui. A web
// (`logica/dinheiro/useDesbloqueio`) e o app (`app/desbloquear/[id].tsx`) montam a mesma, daqui
// (31/10/2026, docs/PLANO-APP-NATIVO.md). O app mostra e não vende: a compra é só na web.

const porChave = (chave: string) => INCLUSOES_DO_PRO.find((x) => x.chave === chave);

/** O que o PRO inclui, pelo nome dos módulos no menu (o que a pessoa vê aqui é o que encontra depois). */
export const INCLUSOES_DO_DESBLOQUEIO = [
  porChave('nyta'),
  { chave: 'musicas', titulo: 'Músicas', linha: 'Cadastre quantas faixas quiser, com versões, letras, créditos e os arquivos de cada uma.' },
  { chave: 'venda', titulo: 'Vendas de shows', linha: 'O CRM das negociações: cada contratante, proposta e valor, do primeiro contato ao show fechado.' },
  { chave: 'controle', titulo: 'Produção de shows', linha: 'A produção de cada show confirmado: cronograma, equipe, custos e o que foi combinado.' },
  { chave: 'agenda', titulo: 'Agenda', linha: 'Lançamentos, shows e compromissos num calendário só.' },
  { chave: 'equipe', titulo: 'Equipe', linha: 'Convide o seu time para trabalhar no mesmo perfil.' },
  porChave('armazenamento'),
].filter((x): x is { chave: string; titulo: string; linha: string } => !!x);

const ORDEM_DO_CICLO = ['diagnostico', 'planejamento', 'execucao'] as const;

export interface EtapaDaJornada {
  chave: string;
  numero: number;
  rotulo: string;
  titulo: string;
  linha: string;
  concluido: boolean;
  atual: boolean;
  bloqueado: boolean;
  letras: { letra: string; acesa: boolean }[] | null;
  detalhe: string | null;
  cta: string;
  /** A etapa feita abre (o painel do artista); as outras não. */
  abrir: (() => void) | null;
}

/** As etapas do ciclo na ordem, com a da vez e as trancadas, a partir dos pilares do painel. */
export const etapasDaJornada = (pilares: Pilar[], abrirFeita: (() => void) | null): EtapaDaJornada[] => {
  const naOrdem = ORDEM_DO_CICLO.map((chave) => pilares.find((p) => p.chave === chave)).filter(Boolean) as Pilar[];
  const daVez = naOrdem.findIndex((p) => p.estado !== 'concluido');
  return naOrdem.map((p, i) => ({
    chave: p.chave,
    numero: i + 1,
    rotulo: p.rotulo,
    titulo: p.titulo,
    linha: p.linha,
    concluido: p.estado === 'concluido',
    atual: i === daVez,
    bloqueado: daVez >= 0 && i > daVez,
    letras: p.marcas ? ['R', 'E', 'A', 'L'].map((letra, n) => ({ letra, acesa: !!p.marcas?.[n] })) : null,
    detalhe: p.detalhe ?? null,
    cta: p.cta,
    abrir: p.estado === 'concluido' ? abrirFeita : null,
  }));
};
